module.exports = __webpack_public_path__ + "img/btn2.aaba4075.png";